import { render } from "./NumberStepper.vue?vue&type=template&id=7a03bce6"
import script from "./NumberStepper.vue?vue&type=script&lang=ts"
export * from "./NumberStepper.vue?vue&type=script&lang=ts"
script.render = render

export default script